import React, { useState, useContext, useEffect, Fragment } from 'react';
import axios from 'axios';
import $ from 'jquery';
import Cookies from 'universal-cookie';
import { NavLink } from 'react-router-dom';
import { LoginContext } from '../../hooks/context/LoginContext';
import { Spinner } from 'react-bootstrap';
import { Modal } from 'react-bootstrap';
import FormRow from './FormRow';
import MiSelect from './MiSelect';
import FormInput from './FormInput';
import TextArea from './TextArea';
import CheckIos from '../ui/CheckIos';
import { alertService } from '../../services/alertservice';
import { axiosPost, getApiUrl, MiReplaceAll } from '../../helpers/helperApp';


function SendMailToLand(props){

    const cookies = new Cookies();
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    const { idDoc, docBloqueado, origenProp, infoDocActual } = props;
    const { confApp, apiKey, cicDefAge } = useContext(LoginContext);
    
    const [ sendingMail, saveSendingMail ] = useState(false);
    const [ showModalMail, saveShowModalMail ] = useState(false);
    const [ idAgeModal, saveIdAgeModal ] = useState(cicDefAge);
    const [ subjectModal, saveSubjectModal ] = useState(infoDocActual.defaultsubject);
    const [ mensajeModal, saveMensajeModal ] = useState(infoDocActual.defaultbody); 

    useEffect( () => {                  
              
        return () =>{
            // Token cancelación axios al desmontar componentes
            source.cancel();                    
        } 

    },[idDoc, docBloqueado])
    
    const show = () => {        
        saveShowModalMail(true);        
    }

    const SendMail = async () => {
        saveSendingMail(true);

        const data = new FormData(); 
        data.append("validacion", apiKey());                
        data.append("iddoc", idDoc);
        data.append("idage", idAgeModal);
        data.append("subject", subjectModal);
        data.append("mensaje", mensajeModal);        
        
        const respuesta = await axiosPost(getApiUrl(window.location.origin)+confApp.largecomp.controles.sendmailtoland.senddata, data, source.token);       
        if( typeof respuesta.data === "string" ){
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${confApp.largecomp.controles.sendmailtoland.enviadoko.title}`, {autoClose: true});  
        }else{
            alertService.success(`<i class="fal fa-times-octagon mr-1"></i>${confApp.largecomp.controles.sendmailtoland.enviadook.title}`, {autoClose: true}); 
        }

        saveSendingMail(false);
        saveShowModalMail(false);
    }

    const handleSelect= (selectedItem, nameOfComponent, saveData) => {
        if( selectedItem ){
            saveData(selectedItem.value) 
        }else{
            saveData(0)
        }
    }

    const handleInput = (e, save) => {        
        save(e.target.value)
    }


    return(
        <Fragment>
            {
                idDoc == null || idDoc == undefined || idDoc == 0
                ?
                    null
                :
                    <button 
                    type="button" 
                    onClick={ show } 
                    className={ "btn btn-warning col-2 mb-1 mr-1 mt-1" }
                    disabled={ sendingMail || docBloqueado ? true : false } 
                >
                    <i className="fa-thin fa-paper-plane md-1"></i>
                    <span className='pl-1'>{confApp.largecomp.controles.sendmailtoland.btnsend.title }</span>  
                </button> 

            }
            <Modal
                show={showModalMail}
                onHide={ () => saveShowModalMail(false)}                            
                aria-labelledby="example-custom-modal-styling-title"
                centered={true}                    
                dialogClassName="modal-90w"                                             
            > 
                <Modal.Header closeButton>
                    <h4>{confApp.largecomp.controles.sendmailtoland.modal.header.title}</h4>
                </Modal.Header>                         
                <Modal.Body>
                    <FormRow>                        
                        <MiSelect  
                            estadoForm=  { "" }
                            val=         { idAgeModal }   
                            loading=     { sendingMail ? true : false }
                            id=          { confApp.largecomp.controles.sendmailtoland.modal.idage.id }    
                            name=        { confApp.largecomp.controles.sendmailtoland.modal.idage.name }   
                            label=       { confApp.largecomp.controles.sendmailtoland.modal.idage.label }    
                            placeholder= { confApp.largecomp.controles.sendmailtoland.modal.idage.placeholder }
                            col=         { confApp.largecomp.controles.sendmailtoland.modal.idage.col } 
                            isClearable= { confApp.largecomp.controles.sendmailtoland.modal.idage.isclearable }
                            isSearchable={ confApp.largecomp.controles.sendmailtoland.modal.idage.issearchable }
                            dataType=    { confApp.largecomp.controles.sendmailtoland.modal.idage.datatype }
                            data=        { confApp.largecomp.controles.sendmailtoland.modal.idage.data }
                            required=    { confApp.largecomp.controles.sendmailtoland.modal.idage.required } 
                            disabled=  { confApp.largecomp.controles.sendmailtoland.modal.idage.disabled }
                            readOnly =   { confApp.largecomp.controles.sendmailtoland.modal.idage.readonly }
                            disablethisid={confApp.largecomp.controles.sendmailtoland.modal.idage.disablethisid}
                            disableids={ confApp.largecomp.controles.sendmailtoland.modal.idage.disableids}
                            formulario= { {id:0} }   
                            change= { (selectedItem, nameOfComponent) => handleSelect(selectedItem, nameOfComponent, saveIdAgeModal) }
                        />
                    </FormRow>                    
                    <FormRow>
                        <FormInput                                                        
                            estadoForm= { "" }
                            value=      { subjectModal }
                            loading=    { sendingMail ? true : false }
                            id=         { confApp.largecomp.controles.sendmailtoland.modal.subject.id }   
                            type=       { confApp.largecomp.controles.sendmailtoland.modal.subject.type }  
                            name=       { confApp.largecomp.controles.sendmailtoland.modal.subject.name }   
                            label=      { confApp.largecomp.controles.sendmailtoland.modal.subject.label }                                                       
                            placeholder={ confApp.largecomp.controles.sendmailtoland.modal.subject.placeholder }    
                            col=        { confApp.largecomp.controles.sendmailtoland.modal.subject.col } 
                            required=   { confApp.largecomp.controles.sendmailtoland.modal.subject.required }
                            readonly=   { confApp.largecomp.controles.sendmailtoland.modal.subject.readonly }                                                
                            disabled=   { confApp.largecomp.controles.sendmailtoland.modal.subject.disabled }
                            change=     { e => handleInput(e, saveSubjectModal) }
                            onBlur=     {null} 
                        />
                    </FormRow>
                    <FormRow>                       
                        <TextArea                                                        
                            estadoForm= { "" }
                            value=      { mensajeModal }
                            loading=    { sendingMail ? true : false }
                            id=         { confApp.largecomp.controles.sendmailtoland.modal.mensaje.id }   
                            name=       { confApp.largecomp.controles.sendmailtoland.modal.mensaje.name }
                            rows=       { confApp.largecomp.controles.sendmailtoland.modal.mensaje.rows }      
                            label=      { confApp.largecomp.controles.sendmailtoland.modal.mensaje.label }                                                       
                            placeholder={ confApp.largecomp.controles.sendmailtoland.modal.mensaje.placeholder }    
                            col=        { confApp.largecomp.controles.sendmailtoland.modal.mensaje.col } 
                            required=   { confApp.largecomp.controles.sendmailtoland.modal.mensaje.required }
                            readonly=   { confApp.largecomp.controles.sendmailtoland.modal.mensaje.readonly }                                                
                            disabled=   { confApp.largecomp.controles.sendmailtoland.modal.mensaje.disabled }
                            change=     { e => handleInput(e, saveMensajeModal) }
                            onBlur=     {null} 
                        />
                    </FormRow>                    
                    <p className="font-italic text-center">{ confApp.largecomp.controles.sendmailtoland.modal.txtrequired.title }</p>
                </Modal.Body>
                <Modal.Footer>
                    <div className='text-right'>
                        <button 
                                className="btn btn-success mt-1 mr-1"
                                onClick={ SendMail }
                                disabled={sendingMail == true || idAgeModal == 0 || subjectModal == "" || mensajeModal == "" ? true : false}
                        >
                            {confApp.largecomp.controles.sendmailtoland.modal.btnaceptar.title}
                        </button>                        
                        <button 
                                className="btn btn-danger mt-1"
                                onClick={ () => saveShowModalMail(false) }                                        
                        >
                            {confApp.largecomp.controles.sendmailtoland.modal.btncancelar.title}
                        </button>                                            
                    </div>
                </Modal.Footer>                            
            </Modal>
        </Fragment>                    
            
    )
}

export default SendMailToLand;